/** `teacheck.selectedEpisodeID` — same key as iOS @AppStorage (AppRootView.swift). */
import { DEFAULT_EPISODE_ID, EPISODE_CATALOG } from '@/domain';

export const SELECTED_EPISODE_KEY = 'teacheck.selectedEpisodeID';

export function isPlayableEpisode(id: string | null | undefined): id is string {
  return id != null && EPISODE_CATALOG.some((e) => e.id === id);
}

export function readSelectedEpisodeID(): string {
  try {
    const v = localStorage.getItem(SELECTED_EPISODE_KEY);
    return isPlayableEpisode(v) ? v : DEFAULT_EPISODE_ID;
  } catch {
    return DEFAULT_EPISODE_ID;
  }
}

export function writeSelectedEpisodeID(id: string): void {
  try { localStorage.setItem(SELECTED_EPISODE_KEY, id); } catch { /* private mode */ }
}
